import { ICounter } from './PropsCounter';

import styles from './Counter.module.scss';

const CustomCounter = ({ id, count, allCount, addCount, removeCount }: ICounter): JSX.Element => {
  return (
    <div className={styles.CustomCounter}>
      <div className={`${styles.CustomCounter__remove} ${count === 1 && styles.disable}`} data-test_id={`${id}-remove`} onClick={removeCount}>
        &#8722;
      </div>
      <div className={styles.CustomCounter__value}>{count}</div>
      <div className={`${styles.CustomCounter__add} ${count === allCount && styles.disable}`} data-test_id={`${id}-add`} onClick={addCount}>
        &#43;
      </div>
    </div>
  );
};

export default CustomCounter;
